module.exports = __webpack_public_path__ + "img/top-50.1daa6493.png";